import { z } from 'zod'

export const transactionFilterSchema = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  integrationId: z.string().uuid().optional(),
  syncStatus: z.enum(['pending', 'synced', 'error']).optional(),
  minAmount: z.number().optional(),
  maxAmount: z.number().optional(),
  search: z.string().optional(),
  category: z.string().optional(),
  vendor: z.string().optional(),
})

export const glEntrySchema = z.object({
  glAccount: z
    .string()
    .min(1, 'GL account is required')
    .regex(/^\d{4,10}(-\d{2,4})?$/, 'Invalid GL account format'),
  amount: z.number().refine((val) => val !== 0, 'Amount cannot be zero'),
  memo: z.string().max(500).optional(),
  department: z.string().optional(),
  location: z.string().optional(),
})

export const journalEntrySchema = z.object({
  journalId: z.string().min(1, 'Journal ID is required'),
  description: z.string().min(1, 'Description is required').max(200),
  entries: z
    .array(glEntrySchema)
    .min(2, 'At least two entries are required')
    .refine(
      (entries) => {
        const total = entries.reduce((sum, e) => sum + e.amount, 0)
        return Math.abs(total) < 0.01 // Allow for floating point precision
      },
      { message: 'Journal entries must balance (debits must equal credits)' }
    ),
})

export const transactionCategorySchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string().min(1, 'Category name is required').max(100),
  glAccount: z.string().optional(),
  description: z.string().max(500).optional(),
})

export type TransactionFilterInput = z.infer<typeof transactionFilterSchema>
export type GLEntryInput = z.infer<typeof glEntrySchema>
export type JournalEntryInput = z.infer<typeof journalEntrySchema>
export type TransactionCategoryInput = z.infer<typeof transactionCategorySchema>